import { render, staticRenderFns } from "./exportAcademicActivity.vue?vue&type=template&id=13311340&scoped=true"
import script from "./exportAcademicActivity.vue?vue&type=script&lang=js"
export * from "./exportAcademicActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13311340",
  null
  
)

export default component.exports